import { SET_ACTIVE_PAGE } from 'ACTIONS';

export const setPpsActivePage = (dispatchID, page = 1) => ({
    type: SET_ACTIVE_PAGE,
    payload: page,
    dispatchID
});
